import MdNotifications from './index'

const NotificationStore = {
  state: [],
  removeNotification(index) {
    this.state.splice(index, 1)
    global.pageNotFound = false
  },
  notify(notification) {
    this.state.push(notification)
  },
  removeAll() {
    this.state.forEach((n) => {
      this.removeNotification(n)
    })
  },
  reset() {
    this.state = []
  }
}

export default {
  install(Vue) {
    Object.defineProperty(Vue.prototype, '$notifications', {
      get() {
        return NotificationStore
      }
    })
    Vue.component('MdNotifications', MdNotifications)
  }
}



// WEBPACK FOOTER //
// ./src/core/components/mdNotifications/install.js